import { api } from "./configs/axiosConfigs";

export const MembershipAPI = {
  getMembers: async (status = "active") => {
    const response = await api.get(
      `/members?page=1&items_per_page=2000&status=${status}`,
    );
    return response?.data;
  },

  getMemberDirectory: async (status = "active") => {
    const response = await api.get(
      `/members/directory?page=1&items_per_page=2000&status=${status}`,
    );
    return response?.data;
  },

  getMember: async (id) => {
    const response = await api.get(`/members/${id}`);

    return response?.data;
  },

  addMember: async (member) => {
    const response = await api.post(`/members`, member);

    return response?.data;
  },

  updateMember: async (member, id) => {
    const response = await api.patch(`/members/${id}`, member);

    return response?.data;
  },

  getMemberWeeklyMeets: async (id) => {
    const response = await api.get(
      `/members/${id}/weekly_meets?page=1&items_per_page=2000&order_by=id&order=asc`,
    );

    return response?.data;
  },

  getMeetUp: async (id) => {
    const response = await api.get(
      `/members/${id}/meetups?page=1&items_per_page=2000&order_by=meetup_date&order=desc`,
    );

    return response?.data;
  },

  getReferral: async (id, type) => {
    const response = await api.get(
      `/members/${id}/referrals?page=1&items_per_page=2000&type=${type}`,
    );

    return response?.data;
  },
  getClosedBusiness: async (id, type) => {
    const response = await api.get(
      `/members/${id}/closed_businesses?page=1&items_per_page=2000&type=${type}`,
    );

    return response?.data;
  },

  getVisitor: async (id, type) => {
    const response = await api.get(
      `/members/${id}/visitors?page=1&items_per_page=2000`,
    );

    return response?.data;
  },

  getMemberPoints: async (
    id,
    start_date = "2024-11-30",
    end_date = "2050-01-01",
  ) => {
    const response = await api.get(
      `/members/${id}/points?start_date=${start_date}&end_date=${end_date}&items_per_page=2000&page=1`,
    );

    return response?.data;
  },
};
